import styled, { css } from "styled-components";
export interface CodeBtnProps {
	imgUrl: string;
	width?: number;
	height?: number;
}
export const CodeBtn = styled("div").withConfig({
	shouldForwardProp: (prop) => !["height", "width", "imgUrl"].includes(prop),
})<CodeBtnProps>`
	background-image: ${(props: CodeBtnProps) => `url(${props.imgUrl})`};
	${(props: CodeBtnProps) => {
		return css`
			height: ${props.height}px;
			width: ${props.width}px;
		`;
	}}
	border: none;
	background-size: cover;
	cursor: pointer;
	:focus {
		outline: none;
	}
`;
export const CouponContainer = styled.section`
	width: 100%;
	height: fit-content;
	margin-bottom: 10px;
`;

export interface InnerBoxProps {
	columnSize: number;
	rows: number;
}
export const InnerBox = styled("div").withConfig({
	shouldForwardProp: (prop) => !["rows", "columnSize"].includes(prop),
})<InnerBoxProps>`
	margin: 0 auto;
	width: 1200px;
	display: grid;
	grid-row-gap: 20px;
	grid-template-rows: ${(props: InnerBoxProps) => `repeat(${props.rows},175px)`};
	${(props: InnerBoxProps) => {
		switch (props.columnSize) {
			case 2:
				return `
				grid-template-columns: 590px 590px;
				grid-column-gap: 20px;
				`;
			case 3:
				return `
				grid-template-columns: repeat(3, 386px);
				grid-column-gap: 21px;
					`;
			default:
				return null;
		}
	}};
`;
